<template>
  <div
    :class="`page-header-wrapper ${bg ? '' : 'page-header-wrapper-bg'}`"
    :style="`${bg ? `background:${bg};` : ''}`"
  >
    <div class="page-header poppins">
      <div class="page-header-box fixed-page-header">
        <h1 v-if="showTitle">
          {{ (title || $route.meta.title) | i18n }}
        </h1>
        <div class="action-buttons">
          <slot name="action-buttons" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      default: '',
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    bg: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.page-header-wrapper-bg {
  background: #fff;
}
.page-header-wrapper {
  top: 0px;
  position: sticky;
  z-index: 5;
}
.page-header {
  display: flex;
  margin: 0px;
}
.page-header h1 {
  color: rgb(95, 95, 95) !important;
  font-size: 1.6rem !important;
  font-weight: 300;
  margin: 10px 10px 10px 0;
  white-space: nowrap;
}
.page-header-box {
  display: flex;
  justify-content: space-between;
  flex: 1;
  flex-wrap: wrap;
}

.action-buttons button {
  margin: 10px 0;
}
</style>
